import type { EntityProfile } from "../../../../../../types/types.MDM";
import type { PIMProduct } from "../../../../../../types/types.PIM";

/**
 * Map an MDM EntityProfile into a PIMProduct-shaped object so the existing
 * CompareProducts util / section components can render without forking.
 * Entity profiles expose `schema` + top-level groups/collections; products
 * nest those under `product_schema`.
 */
export function entityProfileToCompareProduct(
  entity: EntityProfile
): PIMProduct {
  const schema = entity.schema;
  return {
    id: entity.id,
    name: entity.name,
    product_number: entity.entity_number || entity.id,
    status: entity.status,
    product_schema: {
      is_frozen: schema?.is_frozen ?? false,
      collections: entity.collections ?? [],
      description: schema?.description ?? null,
      display_name: schema?.display_name || schema?.template_name || "",
      show_mandatory_completion_score:
        schema?.show_mandatory_completion_score ?? false,
      show_total_completion_score: schema?.show_total_completion_score ?? false,
      show_schema_tag: schema?.show_schema_tag ?? false,
      schema_tags: schema?.schema_tags ?? null,
      template_id: schema?.template_id,
      template_name: schema?.template_name ?? "",
      groups: entity.groups ?? [],
      tenant_id: schema?.tenant_id ?? entity.tenant_id,
      layout: entity.layout ?? schema?.layout ?? [],
    },
  } as PIMProduct;
}
